// extracted by mini-css-extract-plugin
export var select = "SelectInput-module--select--6f858";
export var button = "SelectInput-module--button--07ff1";
export var opened = "SelectInput-module--opened--04585";
export var arrowIcon = "SelectInput-module--arrowIcon--d6717";
export var dropdown = "SelectInput-module--dropdown--8c123";
export var error = "SelectInput-module--error--240c3";
export var selected = "SelectInput-module--selected--86ac4";
export var placeholder = "SelectInput-module--placeholder--506ea";
export var input = "SelectInput-module--input--98dc0";
export var arrow = "SelectInput-module--arrow--fb799";
export var title = "SelectInput-module--title--9fe53";
export var option = "SelectInput-module--option--89567";
export var checkmark = "SelectInput-module--checkmark--27653";
export var optionSelected = "SelectInput-module--optionSelected--822af";
export var emptySearchResult = "SelectInput-module--emptySearchResult--f2af8";